import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from} from "rxjs";
 
import {Subscription} from "rxjs"; 
import {delay, map, switchMap} from 'rxjs/operators';
import {ActivatedRoute, Params} from '@angular/router';
import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {AnalyticService} from '../../shared/services/analytic.service'
import { NbDialogService, NbToastrService, NbGlobalPosition } from '@nebular/theme';
import {StatModalKeysComponent} from '../../shared/components/stat-modal-keys/stat-modal-keys.component'
 import {domain, protocol} from '../../shared/config';
 
@Component({
  selector: 'app-statistics-inner-page', 
  templateUrl: './statistics-inner-page.component.html',
  styleUrls: ['./statistics-inner-page.component.scss'],
  
})
export class StatisticsInnerPageComponent implements OnInit, OnDestroy, AfterViewInit{
 
    lSub$:any;
    clearSub$:any;
	  domain: any = {
    name: domain, protocol
  }
  togglePublish$:any;
    stat:any;
    stream_id:string;
   openLink:string;
  loading:boolean = true;
  publishDisabled = false
  @ViewChild('clearModal') clearModal: any;

  constructor(      private toastrService: NbToastrService,
     private dialogService: NbDialogService, 
	 private analyticService: AnalyticService,
	 public route:  ActivatedRoute   ){
  }
   
 
   ngOnInit() { 


	
 	this.lSub$ = this.route.params.pipe(
      switchMap((params: Params)=>{
        	this.stream_id = params['stream']
        return this.analyticService.getStat(this.stream_id).pipe(
          map((stat: any)=>{
 
	    this.stat =stat

		// setTimeout(()=>{ },4000)
	   this.loading = false

	 this.openLink = `${this.domain.protocol}${this.domain.name}/stat/${stat._id}`
            return stat
          })
        )
      })
    ).subscribe(()=>{})
 
	 


/*
    this.lSub$ = this.analyticService.getOverview().subscribe((data) =>{
		this.statItems = data.streams
			
		this.loading = false
	})
  	*/
  }

  
  setPublish(publish){
	if(this.togglePublish$){
		this.togglePublish$.unsubscribe()
	}

   this.publishDisabled = true
 
    this.togglePublish$ = this.analyticService
    .updatePublish(this.stat.stream_id,publish)
	     .subscribe((p : any)=>{
 
 	     this.publishDisabled = false
	     this.stat.publish = p

	    }, ()=>{
		this.publishDisabled = false
	        
	    })
	 
  }



   showToastCopyClipboard(text){

    this.toastrService.show('',text,{
      status: 'primary',
      icon: '',
      position: <NbGlobalPosition>'bottom-end'
        })
   }




 refresh(){

	if(this.lSub$){
		this.lSub$.unsubscribe()
	}
		this.loading = true
	this.lSub$ =   this.analyticService.getStat(this.stream_id).subscribe( (stat: any)=>{
 
	    this.stat = stat
	   this.loading = false
            
          })
         
}
 

clear(ref:any){

  ref.close()
  if(this.clearSub$){
		this.clearSub$.unsubscribe()
	}
		this.loading = true
	this.clearSub$ =   this.analyticService.clearStat(this.stream_id).subscribe( (stat: any)=>{
  
	   this.loading = false
     this.refresh()
            
          }, ()=>{

            this.toastrService.show('','Сталася помилка',{
              status: 'danger',
              icon: '',
              position: <NbGlobalPosition>'bottom-end'
                })
            this.loading = false
          })
}



openClearDialog(){
  this.dialogService.open(this.clearModal  )

}

  
   ngAfterViewInit() {
 
   }
 
   ngOnDestroy() {
   	if(this.lSub$){
		this.lSub$.unsubscribe()
	}
	if(this.togglePublish$){
		this.togglePublish$.unsubscribe()
	}
	if(this.clearSub$){
		this.clearSub$.unsubscribe()
	}

 
	
   }
 
 



   openKeysModal(){
 
    this.dialogService.open(StatModalKeysComponent, {
      dialogClass: 'settings-modalsscrollable-container',
      context: {
        stream_id: this.stat.stream_id 
      },
    });


   }
   
/**/
 
  
}
